import React, { useMemo } from "react";
import { Box, Button } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InsightsIcon from "@mui/icons-material/Insights";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import SpaIcon from "@mui/icons-material/Spa";
import GrassIcon from "@mui/icons-material/Grass";
import CloudIcon from "@mui/icons-material/Cloud";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AgricultureIcon from "@mui/icons-material/Agriculture";

import { useTranslate } from "../Translate/TranslateContext";
import { useRegional } from "../Regional/RegionalContext";

export default function DashboardTopSelector({ page, setPage, PAGES }) {
    const { translate } = useTranslate();
    const { fieldTerm } = useRegional();

    const options = useMemo(
        () => [
            {
                key: PAGES.OVERVIEW,
                label: "overview",
                icon: DashboardIcon,
            },
            {
                key: PAGES.ALERTS,
                label: "alerts",
                icon: WarningAmberIcon,
            },
            {
                key: PAGES.BENCHMARKS,
                label: "benchmarks",
                icon: InsightsIcon,
            },
            {
                key: PAGES.FARMMANAGEMENT,
                label: "farm_management",
                icon: PlumbingIcon,
            },
            {
                key: PAGES.CROPPERFORMANCE,
                label: `${fieldTerm}_profile`,
                icon: SpaIcon,
            },
            {
                key: PAGES.SOIL,
                label: "garden_soil",
                icon: GrassIcon,
            },
            {
                key: PAGES.FORECAST,
                label: "weatherForecast",
                icon: CloudIcon,
            },
            {
                key: PAGES.ACTIVITY,
                label: "activity_log",
                icon: HistoryEduIcon,
            },
            {
                key: PAGES.FARM,
                label: "data_dashboard",
                icon: AgricultureIcon,
            },
        ].filter((option) => option.key),
        [PAGES, fieldTerm]
    );

    return (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {options.map((option) => {
                const active = page === option.key;
                const Icon = option.icon;
                const foreground = active ? "#FFFAF1" : "#052812";

                return (
                    <Button
                        key={option.key}
                        onClick={() => setPage(option.key)}
                        startIcon={<Icon sx={{ color: foreground }} />}
                        sx={{
                            borderRadius: "999px",
                            px: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            background: active ? "#24582A" : "#D4E9CF",
                            color: foreground,
                            "&:hover": {
                                background: active ? "#17371A" : "#c6dfbf",
                            },
                        }}
                    >
                        {translate(option.label)}
                    </Button>
                );
            })}
        </Box>
    );
}
